import { Injectable } from '@angular/core';
import { Http , Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { Router } from '@angular/router';
import {ParentService} from '../A2-utils/ParentClass/ParentService';

import {constant} from '../../app.constants';

@Injectable()
export class ChangePasswordService extends ParentService{

  constructor( private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }


  changePass(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_CHANGE_PASSWORD, bodyString, this.headerPost())
    .map((res: Response) => res.json() )
    .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/change-password/change-password.service.ts